import { render, staticRenderFns } from "./ResidentGroupList.vue?vue&type=template&id=574812cc&scoped=true&lang=pug"
import script from "./ResidentGroupList.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupList.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupList.vue?vue&type=style&index=0&id=574812cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574812cc",
  null
  
)

export default component.exports